<template>
  <div class="brand-zhiyou-component">
    <div class="brand-section app-basic-layout-wrapper">
      <h3 class="title font-30">品牌号-品牌挚友</h3>
      <p class="subtitle font-color-white">
        品牌与KOL之间强关联关系建立，公域流量沉淀至品牌私域
      </p>
      <div class="body">
        <div class="item-wrapper">
          <h3 class="item-title">
            <div class="icon">
              <i class="iconfont icon-liuliang"></i>
            </div>
            公私域流量转化
          </h3>
          <p class="item-subtitle">社交资产最大化</p>
          <p class="desc">
            品牌号挚友营销样式与品牌内容强绑定挚友公域流量向品牌私域流量转化
          </p>
        </div>
        <div class="item-wrapper">
          <h3 class="item-title">
            <div class="icon">
              <i class="iconfont icon-juhe"></i>
            </div>
            挚友内容沉淀聚合
          </h3>
          <p class="item-subtitle">内容长尾价值增益</p>
          <p class="desc">
            品牌号挚友内容聚合于品牌号&搜索品专关键词信息集中呈现产生稳定内容入口
          </p>
        </div>
        <div class="item-wrapper">
          <h3 class="item-title">
            <div class="icon">
              <i class="iconfont icon-tisheng"></i>
            </div>
            营销工具叠加提效
          </h3>
          <p class="item-subtitle">营销效果1+1</p>
          <p class="desc">
            挚友与其他含KOL的营销工具叠加最大化扩充品牌兴趣用户
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.brand-zhiyou-component {
  background: url('~@/assets/img/brand/zhiyou-bg.png') no-repeat top center /
    cover;
  height: 537px;
  .brand-section {
    .title {
      color: #ffffff;
      &:after {
        background-color: #ffffff;
      }
    }
  }
  .body {
    padding-top: 60px;
    display: flex;
    justify-content: space-between;
  }
  .item-wrapper {
    background-color: rgba(0, 0, 0, 0.65);
    width: 378px;
    height: 210px;
    box-sizing: border-box;
    border-radius: 4px;
    overflow: hidden;
    color: $text-color-yellow;
    padding: 30px 24px;
    .item-title {
      font-size: 24px;
      display: flex;
      align-items: center;
      margin: 0 0 20px;
      .icon {
        width: 40px;
        height: 40px;
        line-height: 40px;
        border-radius: 50%;
        text-align: center;
        border: 1px solid $text-color-yellow;
        margin-right: 16px;
        i {
          font-size: 28px;
        }
      }
    }
    .item-subtitle {
      padding-left: 56px;
      margin: 0 0 12px;
    }
    .desc {
      color: $sub-color-4;
      padding-left: 56px;
      font-size: 14px;
      line-height: 22px;
    }
  }
}
</style>
